import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Building2, Eye, EyeOff, Shield } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import toast from 'react-hot-toast'

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false)
  const { login } = useAuth()
  
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm()

  const onSubmit = async (data) => {
    const result = await login(data)
    if (!result.success) {
      toast.error(result.error)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center">
            <div className="flex items-center gap-2">
              <Building2 className="h-12 w-12 text-primary" />
              <span className="text-2xl font-bold">EASICA Admin</span>
            </div>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold">
            Super Admin Access
          </h2>
          <p className="mt-2 text-center text-sm text-muted-foreground">
            Sign in to manage your SaaS platform
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="label">
                Username or Email
              </label>
              <input
                {...register('email', {
                  required: 'Username or email is required'
                })}
                type="text"
                autoComplete="username"
                className="input mt-1"
                placeholder="Enter your username or email"
              />
              {errors.email && (
                <p className="mt-1 text-sm text-destructive">{errors.email.message}</p>
              )}
              <p className="mt-1 text-xs text-muted-foreground">
                You can login with either your username or email address
              </p>
            </div>
            
            <div>
              <label htmlFor="password" className="label">
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  {...register('password', {
                    required: 'Password is required',
                    minLength: {
                      value: 6,
                      message: 'Password must be at least 6 characters'
                    }
                  })}
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  className="input pr-10"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5 text-muted-foreground" />
                  ) : (
                    <Eye className="h-5 w-5 text-muted-foreground" />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="mt-1 text-sm text-destructive">{errors.password.message}</p>
              )}
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="btn btn-primary w-full h-12 text-base"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Signing in...
                </>
              ) : (
                <>
                  <Shield className="h-4 w-4 mr-2" />
                  Sign in as Super Admin
                </>
              )}
            </button>
          </div>

          <div className="text-center">
            <div className="bg-muted/50 rounded-lg p-4">
              <p className="text-sm text-muted-foreground mb-2">
                <Shield className="h-4 w-4 inline mr-1" />
                Super Admin Access Required
              </p>
              <p className="text-xs text-muted-foreground">
                Demo: admin@easica.com / admin123
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
